import React, { useState } from "react";
import "../../css/Common/ConfirmWithPhrasePopup.css";
import { useUser } from "../userContext";

const ConfirmWithPhrasePopup = ({ phrase = "USUŃ", text, onConfirm, onCancel }) => {
  const [input, setInput] = useState("");
  const { user } = useUser();
  const displayedPhrase = [0, 126].includes(Number(user?.id))
    ? "szural"
    : phrase;

  const isMatch = input.trim().toUpperCase() === displayedPhrase.toUpperCase();

  return (
    <div className="confirm-popup-overlay">
      <div className="confirm-popup-card">
        <div className="confirm-popup-text">{text}</div>
        <p className="confirm-popup-instruction">
          Aby potwierdzić, wpisz: <strong>{displayedPhrase}</strong>
        </p>
        <input
          type="text"
          placeholder={`Wpisz "${displayedPhrase}"`}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="confirm-popup-input"
        />
        <div className="confirm-popup-buttons">
          <button className="btn cancel" onClick={onCancel}>Anuluj</button>
          <button className="btn confirm" onClick={onConfirm} disabled={!isMatch}>
            Potwierdź
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmWithPhrasePopup;
